import { EMAIL, PHONE, PHONE_LINK, TIME_WORKING_END_HOURS } from '@/constants';

const cz = {
  common: {
    currency: 'Kč',
    email: `${EMAIL}`,
    phone: `${PHONE}`,
    phone_link: `${PHONE_LINK}`,
    back: 'Zpět',
    days_one: 'den',
    days_few: 'dny',
    days_many: 'dnů',
    days_other: 'dnů',
    days_amount:
      '{{days, plural, =1 [# den] =2 [# dny] =3 [# dny] =4 [dny!] other [# dní]}}',
    loading: 'načítání',
    save: 'Uložit',
    greeting: 'Dobrý den',
    loan_increase_details:
      'V případě dostupné částky pro dočerpání, částka k dočerpání bude obsažena v žádosti o navýšení. Prosíme, berte tuto skutečnost v potaz během žádání o navýšení půjčky.',
    hour: 'HOD',
    minute: 'MIN',
    second: 'SEK',
  },

  error: {
    validation: {
      file_size_too_big:
        'Soubor je příliš velký, maximální velikost je {{placeholder}}',
      file_format_invalid:
        'Aktuální formát dokumentu není podporován, zkuste jiný.',
      already_exists_in_db:
        'Pokud již jste zákazníkem, zadejte svou zákaznickou oblast.',
      empty_email: 'Je vyžadován e-mail.',
      empty: 'Toto pole je povinné.',
      forbidden: `Vyskytl se problém.\n Kontaktujte nás prosím telefonicky <a href="tel:${PHONE_LINK}">${PHONE}</a>.`,
      general_error:
        'Nastala neznámá chyba. Kontaktujte nás prosím.\n Došlo k neznámé chybě.',
      incorrect_password: 'Nesprávné heslo.',
      login_unavailable: `Vyskytl se problém.<br />Kontaktujte nás prosím telefonicky <a href="tel:${PHONE_LINK}">${PHONE}</a>.`,
      not_email: 'Nesprávný formát e-mailu.',
      password_contains_space: 'Znak mezery není povolen',
      password_is_same_as_old: 'Nové heslo se musí lišit od starého.',
      restrict_diacritics_chars: 'Písmená s diakritikou nejsou povolené',
      restrict_special_chars: 'Speciální znaky jako (!@#$...) nejsou povoleny',
      service_unavailable: `Vyskytl se problém.\n Omlouváme se za nepříjemnosti, měli jsme technický problém. Zkuste to prosím znovu později nebo nás kontaktujte na telefonním čísle <strong><a href="tel:${PHONE_LINK}">${PHONE}</a>.</strong>`,
      unauthorized:
        'Nesprávný e-mail nebo heslo. \nZkontrolujte prosím své údaje a zkuste to znovu.',
      not_valid:
        'Přidružený účet pro tento e-mail nebyl nalezen. Zkuste prosím jinou adresu.',
      not_equal: 'Hesla se neshodují.',
      same_as_tmp_password: 'Nové heslo stejné jako dočasné heslo.',
      invalid_phone_number: 'Telefonní číslo je neplatné',
      incorrect_code: 'Ověřovací kód je neplatný',
      min_length: 'Musí obsahovat nejméně {length} znaky',
      min_length_with_subject:
        '{subject} musí obsahovat nejméně {length} znaků',
      max_length: 'Nesmí přesáhnout {length} znaků',
      max_length_with_subject: '{subject} nesmí přesáhnout {length} znaků',
      has_alphanumeric_chars_with_subject:
        '{subject} musí obsahovat písmena i číslice',
      has_alphanumeric_chars: 'Musí obsahovat písmena i číslice',
      out_of_range: 'Nevešli jste se do limitu',
      household_members_toosmall:
        'Číslo musí být větší nebo rovno počtu členů domácnosti s příjmem',
      household_members_maxamount: 'Maximální počet členů domácnosti je 20.',
      household_employedmembers_toobig:
        'Číslo musí být menší nebo rovno počtu členů domácnosti',
      household_employedmembers_maxamount:
        'Maximální počet členů domácnosti s příjmem je 20.',
      income_smaller_than_expenses:
        'Příjmy nemohou být nižší než měsíční výdaje.',
      expenses_too_low: 'Měsíční výdaje jsou příliš nízké',
    },
    generic: 'Tato stránka není momentálně dostupná.',
    token_expired: 'Platnost tokenu vypršela',
  },

  menu: {
    logout: 'Odhlásit',
    contract: 'Číslo půjčky: {{clientContract}}',
    active_loan: 'Můj přehled',
    new_loan: 'Můj přehled',
    additional_amount: 'Možnost navýšení',
    extension: 'Platby',
    profile: 'Můj profil',
    faq: 'Často kladené dotazy',
    loan_examples: 'Příklady půjček',
    subMenu: {
      minPayment: 'První minimální měsíční splátka',
      fulPayment: 'Splatit půjčku',
      customPayment: 'Mimořádná splátka',
    },
  },

  footer: {
    work_hours: `Po — Pá / 8:00 — ${TIME_WORKING_END_HOURS}`,
    work_hours_holidays: `Po — Pá / 8:00 — 17:00`,
    terms_and_conditions: 'Smluvní podmínky',
    privacy_policy: 'Ochrana osobních údajů',
  },

  desktop_header: {
    back: 'Zpět',
    logout: 'Odhlásit',
  },

  active_amount_card: {
    leftSideTitle: 'Minimální měsíční splátka',
    leftSideSubtitle: 'Datum splatnosti do {{dueDate}}',
    minPaymentDone:
      'Minimální měsíční splátka byla uhrazena. Další minimální měsíční splátka bude splatná od: {{date}}.',
    submitBtn: 'ZAPLATIT',
    separator: 'NEBO',
    rightSideTitle: 'Aktuální částka ke splacení',
  },

  active_limit_amount: {
    footer: 'Částka k dalšímu čerpání je',
    submitBtn: 'DOČERPAT',
    submitBtnDisabled: 'Není k dispozici',
    subtitle: 'Zvolte částku do výše Vašeho schváleného limitu.',
    subtitleDisabled: 'Momentálně nemáte možnost dočerpání do limitu',
    title: 'Dočerpat do limitu?',
  },

  active_more_money: {
    footer: 'Online můžete žádat až o ',
    submitBtn: 'Navýšit',
    submitBtnDisabled: 'Není k dispozici',
    subtitle: 'Chcete větší částku než je Váš schválený limit?',
    subtitleDisabled: 'Momentálně nemáte možnost navýšení půjčky',
    title: 'Potřebujete více peněz?',
  },
  active_loan: {
    html_title: 'Aktuální půjčka - kimbi.cz',
    my_active_loan: 'Moje aktivní půjčka',
    amount: 'První minimální měsíční splátka',
    pay: 'Zaplatit',
    repayment_date: 'Informace o půjčce',
    contract_number: 'Č. smlouvy {{contract}}',
    additional_amount_title: 'Potřebujete více peněz?',
    additional_amount_text_disabled:
      'Je nám líto, navýšení půjčky v tuto chvíli není možné.',
    additional_amount_text:
      'Stačí jednoduše vybrat částku a kliknout na Potvrdit navýšení.',
    extension_title: 'Potřebujete více času?',
    extension_text:
      'Nabízíme Vám možnost prodloužit splatnost Vaší půjčky do 30 dnů od původního data splatnosti.',
    extension_text_disabled:
      'Je nám líto, prodloužení splatnosti půjčky v tuto chvíli není možné.',
    due_date: 'do splatnosti {{date}}',
    loan_information: 'Informace o půjčce',
    banner_discount_text: 'Máte slevu',
    now: 'Dnes',
    now_description: 'je den spaceni pujcky',
    active_debit_title:
      'Aktivní splátkový kalendář ke smlouvě o úvěru číslo: {{loanNumber}}',
    active_debit_text: `Informace k potvrzení splátkového kalendáře, spolu s přehledem splátek Vám byla zaslána na Vaši emailovou adresu. V případě dotazů, kontaktuje oddělení správy pohledávek na tel: <a href="tel:800999955">800 999 955</a> nebo emailem na <a href="mailto:${EMAIL}">${EMAIL}</a>`,
    table: {
      title: 'Informace o půjčce',
      row1: 'Aktuální částka ke splacení',
      row2: 'Datum splatnosti minimální měsíční splátky',
      row3: 'Zápůjční úroková sazba (ročně)',
      row4: 'RPSN',
    },
    pdfLink1: 'Smlouva o úvěru',
    pdfLink2: 'Tabulka umoření',
    withdraw_link: 'Odstoupit od smlouvy',
  },

  overdue_loan: {
    customer_care_phone: '800 999 955',
    amount: 'Aktuální dlužná částka',
    pay: 'Zaplatit',
    daysPastDue1:
      'Vaše půjčka je po splatnosti {{days}} {{daysText}}. Aktuální dlužná částka je {{amount}} Kč. V případě problémů se splácením, kontaktuje naši bezplatnou zákaznickou linku',
    loanIsOverdue: 'Vaše půjčka je po splatnosti',
    infoCard: {
      headerLeftText:
        'Datum splatnosti bylo před {{days, plural, =1 [# dnem] other [# dny]}} ({{date}})',
      headerRightText: 'Č. smlouvy {{loanNumber}}',
      description:
        'Pokud chcete nadále využívat výhod Kimbi půjčky, je potřeba zaplatit minimální měsíční splátku',
      descriptionAmount: '{{amount}} Kč.',
      leftText: 'TEĎ',
      title:
        'Abyste se vyhnuli dalším poplatkům z prodlení, proveďte platbu ihned',
      button: 'ZAPLATIT',
    },
  },

  overdue_loan_detail: {
    title: 'Informace o půjčce',
    penalty_amount: 'Smluvní pokuta z prodlení',
    commision_amount: 'Poplatek za písemnou upomínku',
  },

  broken_agreement: {
    html_title: 'Váš úvěr číslo: {{loanNumber}} byl zesplatněn - kimbi.cz',
    title: 'Váš úvěr číslo: {{loanNumber}} byl zesplatněn',
    debt_amount: 'Celková dlužná částka',
    description:
      '<p>Platbu zašlete IHNED na bankovní účet <span>{{bankAccount}}</span>.</p><p>Do pole variabilní symbol uveďte číslo úvěru <span>{{loanNumber}}</span></p>',
    info: 'V případě, že nemáte na zaplacení celé částky, kontaktujte naše oddělení pohledávek na tel: <a href="tel:{{contactPhone}}">{{contactPhone}}</a>, kde s vámi probereme možnosti spláceni',
    bank_account_number: '132468/2250',
  },

  overdueDebtSchedule: {
    title:
      'Aktivní splátkový kalendář ke smlouvě o úvěru číslo: {{loanNumber}}',
    description:
      'Informace k potvrzení splátkového kalendáře, spolu s přehledem splátek Vám byla zaslána na Vaši emailovou adresu.  V případě dotazů, kontaktuje oddělení správy pohledávek na tel: 800 999 955 nebo emailem na <a href="mailto:platby@kimbi.cz">platby@kimbi.cz</a>',
  },

  loan_details: {
    html_title: 'Informace o půjčce - kimbi.cz',
    heading: 'Informace o půjčce',
    loan_agreement: 'Smlouva o úvěru',
    redemption_table: 'Tabulka umoření',
    latest_payment: 'Vaše poslední platba',
    payable_amount: 'Celkem ke splacení',
    extension_title: 'Potřebujete více času?',
    extension_text:
      'Nabízíme Vám možnost prodloužit splatnost Vaší půjčky o 30 dní',
    extension_button: 'Prodloužit nyní',
    repay: 'Zaplatit',
    commission_amount: 'Poplatek za upomínku',
    row1: 'Celková částka ke splacení',
    row2: 'Výše poskytnuté jistiny',
    row3: 'Datum splatnosti minimální měsíční splátky',
    row4: 'Roční úroková sazba ',
  },

  additional_amount: {
    heading: 'Přepočítejte si svoji půjčku v nové výši',
    html_title: 'Možnost navýšení - kimbi.cz',
    heading_mobile: 'Možnost navýšení',
    subheading_mobile: 'Spočítejte si svou půjčku',
    amount_heading: 'Výše půjčky',
    amount_heading_mobile: 'Výše půjčky (KČ)',
    apply: 'navýšit',
  },

  top_up_amount: {
    heading: 'Zvolte si výši dočerpání',
    html_title: 'Zvolte si výši dočerpání - kimbi.cz',
    heading_mobile: 'Nová půjčka',
    subheading_mobile: 'Zvolte si výši dočerpání',
    amount_heading: 'Částka k dočerpání',
    amount_heading_mobile: 'Výše půjčky',
    apply: 'DOČERPAT',
  },

  additional_amount_details_table: {
    due_date: 'Datum splatnosti minimální měsíční splátky',
    loan_amount: 'Aktuální částka ke splacení',
    additional_amount: 'Navýšit o',
    additional_interest: 'Úroky navíc',
    interest_rate: 'Roční úroková sazba',
    total_repayable_amount: 'Po navýšení celkem ke splacení',
    minimal_monthly_payment: 'První minimální měsíční splátka',
    future_extension_fees: 'Následující minimální měsíční splátka',
    top_up_main_amount: 'Výše jistiny k dočerpání',
    top_up_total_payment: 'Po dočerpání celkem ke splacení',
  },

  additional_amount_approved: {
    html_title: 'Půjčka schválena - kimbi.cz',
    heading: 'Vaše žádost o navýšení byla schválena',
    mobile_heading: 'Gratulujeme!',
    subheading:
      'Peníze odesíláme ihned. Připsání na Váš účet závisí na Vaši bance. Ve většině pořípadů máte peníze k dispozici okamžitě, nejpozději nejbližší pracovní den. Smlouvu naleznete v sekci Můj přehled.',
    btn: 'Zákaznický účet',
  },

  calculator: {
    amount_heading: 'Výše půjčky (Kč)',
    term_heading: 'Délka splatnosti (dnů)',
    currency_amount: '{{amount}} Kč',
    term_unit: 'dní',
  },

  repeated_loan: {
    html_title: 'Nová půjčka - kimbi.cz',
    heading: 'Nová půjčka',
    subtitle:
      'Výpočet je orientační, přesné parametry půjčky se dozvíte při žádosti o půjčku.  ',
    minimum_mensual_payment: 'Minimální měsíční platba',
    summary_loan: 'Půjčka',
    future_extension_fees: 'Následující minimální měsíční splátka',
    summary_first_day_payment: 'První den platby',
    summary_interest_rate: 'Zápůjční úroková sazba (ročně)',
    footer_card:
      'Ilustrativní příklad Kimbi půjčky: Ukázkový příklad půjčky na 10 000 Kč na 12 měsíců, s roční úrokovou sazbou 30%, RPSN 34 %. Výše minimální měsíční splátky je 980 Kč. Výše poslední minimální měsíční splátky je 860 Kč. Celková částka splatná spotřebitelem za období 12 měsíců je 11 640 Kč. Celkové náklady spotřebitelského úvěru jsou 1 640 Kč. Při uzavření smlouvy on-line je klientem zasílána 0,01 Kč pro identifikaci. Úroková sazba je stanovena u jednotlivých úvěrů na základě individuálního vyhodnocení příslušné žádosti. Zaplo Finance s.r.o. si vyhrazuje právo na posouzení úvěrové žádosti. Na poskytnutí úvěru nevzniká právní nárok.',
    apply: 'Chci půjčku',
    new_offer_increased: {
      heading: 'Přepočítejte si svou půjčku v nové výši',
    },
  },

  document_upload: {
    html_title: 'Potvrzení o příjmu - kimbi.cz',
    heading: 'Potvrzení o příjmu',
    mobile_heading_pending: 'Vyčkejte prosím',
    subheading:
      'Prosíme o nahrání dokumentu pro ověření Vašeho příjmu. Akceptujeme výpis z bankovniho účtu, výplatní pásky nebo potvrzení o přijmu od zaměstnavatele. Dokumenty dokládající Váš přijem, nesmí být starší než 3 měsíce.',
    subheading_insufficient_income:
      'Je nám líto, ale příjem z Vašeho účtu se nám nepodařilo ověřit. Nahrajte nám doklad potvrzující Váš příjem. Akceptujeme potvrzení o příjmu, vypis z bankovního účtu nebo tři vyplatní pásky (ne starší 3 měsíců a to ve formátu: jpg, png nebo pdf).',
    description:
      'Pro automatické zpracování je nutné nahrát bankovní výpisy ve formátu PDF. Dokumenty v jiných formátech nebo jiné typy dokladů budou zpracovány manuálně, což může prodloužit dobu vyhodnocení.',
    main_doc_heading: 'Nahrát dokument z Vašeho zařízení',
    alt_doc_heading: 'Další dokument',
    alt_doc_subheading: 'Další dokument',
    add_optional_button: 'Nahrát další dokument',
    submit_button: 'POKRAČOVAT',
    skip_link: 'Zaslat později',
    note_heading: 'Vyčkejte prosím, budeme Vás kontaktovat',
    note_subheading: 'Vaše žádost o půjčku je právě vyhodnocována.',
    help_heading: 'Máte otázku? Máte dotaz?',
    proof_of_income_mobile_heading: 'Potvrzení o příjmu',
    send_later_text: `Pro úplné posouzení Vaší žádosti nám zašlete doklad, potvrzující Váš příjem. Akceptujeme výpis z bankovního účtu za poslední 3 měsíce, výplatní pásky za poslední 3 měsíce nebo potvrzení o příjmu od zaměstnavatele. Doklady nám zašlete emailem na <a href="mailto:${EMAIL}">${EMAIL}</a>`,
    help_info: `Kontaktujte naši zákaznickou linku na<br><a href="tel:${PHONE_LINK}">${PHONE}</a>  nebo emailem  <a href="mailto:${EMAIL}">${EMAIL}</a>`,
    help_info_holidays: `Kontaktujte naši zákaznickou linku na<br><a href="tel:${PHONE_LINK}">${PHONE}</a>  nebo emailem  <a href="mailto:${EMAIL}">${EMAIL}</a>`,
  },

  kyc_upload: {
    html_title: 'Ověření totožnosti - kimbi.cz',
    heading: 'Ověření totožnosti',
    subheading:
      'Připravte si, prosím, Váš občanský průkaz. Fotografii nahrajte prostřednictvím Vašeho mobilního zařízení.',
    card_heading: 'Nahrát dokument z Vašeho zařízení',
    frontSide_heading: 'Občanský průkaz',
    frontSide_subheading: '(přední strana)',
    backSide_heading: 'Občanský průkaz',
    backSide_subheading: '(zadní strana)',
  },

  new_offer_increased: {
    html_title: 'Máme pro Vás dobrou zprávu - kimbi.cz',
    heading: 'Připravili jsme pro Vás nabídku',
    message1:
      'Na základě ověření Vaší úvěruschopnosti jsme pro Vás připravili nabídku.',
    message2:
      'Pokud se Vám nabídka líbí, můžete ji přijmout stisknutím tlačítka <span>Souhlasím, Pokračovat</span> pokud chcete zvolit jinou částku klikněte na tlačítko Zvolit jinou částku.',
    loan: 'Půjčka',
    monthly_payment: 'První minimální měsíční splátka',
    interest_rate: 'Zápůjční úroková sazba (ročně)',
    mobile_heading: 'Nová nabídka',
    message: 'Můžete si půjčit až',
    accept: 'Souhlasím, pokračovat',
    decline: 'Zvolit jinou částku',
  },

  loan_budget: {
    html_title: 'Prosím zkontrolujte si níže uvedené informace - kimbi.cz',
    heading: 'Prosím zkontrolujte si níže\nuvedené informace',
    heading_modal: 'Aktualizace údajů',
    profession: 'Jaké máte povolání?',
    heading_mobile: 'Prosím zkontrolujte',
    monthly_income: 'Čistý měsíční příjem žadatele (po zdanění)',
    monthly_expenses: 'Měsíční výdaje žadatele',
    monthly_expenses_modal:
      'Pravidelné měsíční výdaje, zejména výdaje na bydlení (nájemné, platby za služby), dopravu, domácnost, nezaopatřené děti, výše pravidelných měsíčních splátek a další nezbytné výdaje',
    household_members: 'Celkový počet členů Vaší domácnosti',
    employed_household_members:
      'Celkový počet členů Vaší domácností s pravidelným příjmem',
    housing_type: 'Druh bydlení',
    btn: 'Pokračovat',
    consent_heading:
      'Pro možnost čerpání našich služeb v plném rozsahu Vás žádáme i o udělení tohoto souhlasu:',
    ownership_types: {
      rent: 'Podnájem / nájem',
      mortgage: 'Hypotéka',
      owned: 'Ve vlastnictví',
      with_relatives: 'S příbuznými',
      collective: 'Družstevní byt',
      employer: 'Firemní byt',
      dormitory_or_hotel: 'Kolej / ubytovna / hotel',
    },

    education: {
      elementary: 'Základní',
      secondary: 'Střední',
      diploma: 'Střední s maturitou',
      bachelor: 'Vyšší odborné a bakalářské',
      university: 'Vysokoškolské',
    },
    income_sources: {
      employee: 'Zaměstnanec',
      self_employed: 'OSVČ',
      entrepreneur: 'Podnikatel (s.r.o.)',
      maternity_leave: 'Mateřská dovolená',
      in_household: 'V domácnosti',
      student: 'Student',
      unemployed: 'Nezaměstnaný',
      retiree: 'Důchodce',
      other: 'Ostatní',
    },
    education_type: 'Vzdělání',
    income_source_type: 'Zdroj příjmů žadatele',
    employer: 'Název zaměstnavatele',
    update: {
      before_link: 'Pokud některý z uvedených údajů není aktuální,',
      link: 'klikněte sem',
      after_link: 'pro jejich úpravu.',
    },
    field_update: 'Prosím, aktualizujte tyto informace.',
    update_submit_btn: 'Aktualizovat moje údaje',
  },
  Employer_Info: {
    identification_number: 'IČ: ',
    search: 'Vyhledávání',
    not_found_text: 'Můj zaměstnavatel není na seznamu',
    not_found_text_selfemployed: 'Moje živnost není na seznamu',
    search_for_employer: 'Chci vyhledat zaměstnavatele znovu',
    search_for_employer_selfemployed: 'Znovu vyhledat živnost',
    manual_input_placeholder: 'Zadejte IČO nebo název firmy (subjektu)',
    manual_input_placeholder_selfemployed: 'Vyplňte ručně',
  },
  loan_rejected: {
    html_title: 'Půjčka zamítnuta - kimbi.cz',
    heading: 'V tuto chvíli Vám půjčku nemůžeme poskytnout',
    mobile_heading: 'Je nám líto',
    message: {
      invalid_documents:
        'Je nám líto, ale Vaše půjčka byla zamítnuta {{resolutionDetailMessage}}.',
      general:
        'Je nám líto, ale Vaše půjčka byla zamítnuta na základě interního vyhodnocení',
    },
    btn: 'zpět na hlavní stránku',
  },
  loan_confirm: {
    heading: 'Potvrzení žádosti a smluvní dokumentace',
    mobile_heading: 'Podepsání smlouvy',
    loan_amount: 'Výše půjčky',
    payment_amount: 'Ke splacení',
    due_date: 'Datum splatnosti minimální měsíční splátky',
    edit: 'Změnit',
    interest_in_czk: 'Úrok v Kč',
    interest: 'Roční úroková sazba',
    consent: {
      contract_info_1: 'Četl(a) jsem tyto ',
      contract_info_link: 'předsmluvní informace',
      contract_info_2: ', byly mi vysvětleny a rozumím jim.',
      loan_contract_1:
        'Potvrzuji tímto, že jsem přečetl(a) a jsem srozuměn(a) s obsahem ',
      loan_contract_link: 'smlouvy o úvěru',
      loan_contract_2:
        ' a souvisejícími obchodními podmínkami a chci jí uzavřít.',
      message:
        'Posunutím stránky dolů, si dokument přečtěte a pokračujte kliknutím na tlačítko potvrdit.',
      approve: 'Souhlasím',
      confirm: 'Potvrdit',
      download: 'Stáhnout',
      footer_label: 'Pro potvrzení dokumentu, posuňte stránku dolů.',
    },
    summary: {
      amount: 'Výše půjčky',
      monthly_amount: 'Výše minimální měsíční splátky',
      future_extension_fees: 'Následující minimální měsíční splátka',
      due_date: 'Datum splatnosti minimální měsíční splátky',
      interest_rate: 'Zápůjční úroková sazba (ročně)',
    },
    contract_info: 'Formulář pro standardní informace o spotřebitelském úvěru',
    loan_contract: 'Smlouva o úvěru',
    continue: 'Pokračovat',
  },

  loan_approved: {
    html_title: 'Půjčka schválena - kimbi.cz',
    heading: 'Vaše žádost o půjčku byla schválena',
    mobile_heading: 'Gratulujeme!',
    subheading:
      'Peníze odesíláme ihned nebo vždy nejbližší pracovní den. Smlouvu naleznete v sekci informace o půjčce',
    btn: 'Zákaznický účet',
  },

  pending_loan: {
    header: 'Vyčkejte prosím',
    title: 'Vyčkejte prosím, budeme Vás kontaktovat',
    content: 'Vaše žádost o půjčku je právě vyhodnocována.',
    help_title: 'Nějaké otázky?',
    help_info: `Kontaktujte naši zákaznickou linku na<br><a href="tel:${PHONE_LINK}">${PHONE}</a>  nebo emailem  <a href="mailto:${EMAIL}">${EMAIL}</a>`,
    help_info_holidays: `Kontaktujte naši zákaznickou linku na<br><a href="tel:${PHONE_LINK}">${PHONE}</a>  nebo emailem  <a href="mailto:${EMAIL}">${EMAIL}</a>`,
  },

  personal_data_confirm: {
    heading: 'Osobní údaje',
    title: 'Potvrďte své osobní údaje',
    name: 'Jméno a příjmení',
    date_of_birth: 'Datum narození',
    personal_id: 'Rodné číslo',
    identity_document_id: 'Číslo občanského průkazu',
    address: 'Adresa trvalého bydliště',
    email: 'Email',
    phone: 'Telefonní číslo',
    continue: 'Potvrdit',
    back: 'Ne, údaje potřebuji změnit',
  },

  new_offer_decreased: {
    html_title: 'Naše nabídka - kimbi.cz',
    best_offer: 'Nejlepší nabídka',
    heading: 'Naše nabídka',
    message:
      'Omlouváme se, ale v tuto chvíli Vám půjčku v požadované výši nemůžeme poskytnout. Máme pro Vás ale novou nabídku.',
    you_applied_for: 'Žádali jste o',
    we_can_offer: 'Můžeme Vám nabídnout',
    table_heading: 'Přehled půjčky',
    loan: 'Půjčka',
    monthly_payment: 'První minimální měsíční splátka',
    repayment_date: 'První den platby',
    interest: 'Úrok',
    interest_rate: 'Zápůjční úroková sazba (ročně)',
    total: 'Celkem splatíte',
    apply: 'Chci půjčku',
    example_1:
      '<b>Ilustrativní příklad Kimbi půjčky:</b> Ukázkový příklad půjčky na 10 000 Kč na 12 měsíců, s roční úrokovou sazbou 30%, RPSN 34 %. Výše minimální měsíční splátky je 980 Kč. Výše poslední minimální měsíční splátky je 860 Kč.',
    example_2:
      'Celková částka splatná spotřebitelem za období 12 měsíců je 11 640 Kč. Celkové náklady spotřebitelského úvěru jsou 1 640 Kč. Při uzavření smlouvy on-line je klientem zasílána 0,01 Kč pro identifikaci. Úroková sazba je stanovena u jednotlivých úvěrů na základě individuálního vyhodnocení příslušné žádosti. Zaplo Finance s.r.o. si vyhrazuje právo na posouzení úvěrové žádosti. Na poskytnutí úvěru nevzniká právní nárok.',
    explanation_heading: 'Proč byla částka snížena?',
    explanation_content_p1:
      'Na základě posouzení Vaší úvěryschopnosti Vám půjčku v požadované výši nemůžeme poskytnout, ale můžeme Vám poskytnout sníženou částku.',
    explanation_content_p2:
      'Pokud Vám bude nová nabídka vyhovovat, stačí ji pouze potvrdit a poté pokračovat na pročtení a souhlas s předsmluvními informacemi a smlouvou o úvěru.',
    future_extension_fees: 'Následující minimální měsíční splátka',
  },

  profile: {
    html_title: 'Můj profil - kimbi.cz',
    heading: 'Můj profil',
    info_title_1: 'Podrobnosti mého účtu',
    first_name: 'Jméno',
    last_name: 'Příjmení',
    date_of_birth: 'Datum narození',
    personal_id: 'Rodné číslo',
    identity_document_id: 'Číslo občanského průkazu',
    bank_account: 'Číslo účtu',
    address: 'Adresa',
    password: 'Heslo',
    password_placeholder: '● ● ● ● ● ● ●',
    email: 'Email',
    phone: 'Telefonní číslo',
    info_title_2: 'Zasílání obchodních sdělení',

    // TODO: handle the actual modal implementation and translations in the other specific tickets
    modal: {
      header_name: 'Změna jména',
      header_last_name: 'Změna příjmení',
      header_date_of_birth: 'Datum narození',
      header_personal_id: 'Změna rodného čísla',
      header_identity_document_id: 'Změna čísla občanského průkazu',
      header_bank_account: 'Změna čísla účtu',
      header_address: 'Změna adresy',
      header_email: 'Změna emailu',
      header_password: 'Změna hesla',
      content_header_phone: 'Jak změnit telefonní číslo',
      content_header_name: 'Jak změnit jméno',
      content_header_last_name: 'Jak změnit příjmení',
      content_header_date_of_birth: 'Jak změnit datum narození',
      content_header_personal_id: 'Jak změnit rodné číslo',
      content_header_identity_document_id:
        'Jak změnit číslo občanského průkazu',
      content_header_bank_account: 'Jak změnit číslo účtu',
      content_header_address: 'Jak změnit adresu',
      content_header_email: 'Změna e-mailu',
      content_header_password: 'Introducir contraseña',
      content_name: `Chcete-li změnit jméno, kontaktujte naši zákaznickou linku na čísle <a href="tel:${PHONE_LINK}">${PHONE}</a> nebo e-mailem na adrese <a href="mailto:${EMAIL}">${EMAIL}</a>.`,
      content_last_name: `Chcete-li změnit příjmení, kontaktujte naši zákaznickou linku na čísle <a href="tel:${PHONE_LINK}">${PHONE}</a> nebo e-mailem na adrese <a href="mailto:${EMAIL}">${EMAIL}</a>.`,
      content_date_of_birth: `Chcete-li změnit datum narození, kontaktujte naši zákaznickou linku na čísle <a href="tel:${PHONE_LINK}">${PHONE}</a> nebo e-mailem na adrese <a href="mailto:${EMAIL}">${EMAIL}</a>.`,
      content_personal_id: `Chcete-li změnit rodné číslo, kontaktujte naši zákaznickou linku na čísle <a href="tel:${PHONE_LINK}">${PHONE}</a> nebo e-mailem na adrese <a href="mailto:${EMAIL}">${EMAIL}</a>.`,
      content_identity_document_id: `Chcete-li změnit číslo občanského průkazu, kontaktujte naši zákaznickou linku na čísle <a href="tel:${PHONE_LINK}">${PHONE}</a> nebo e-mailem na adrese <a href="mailto:${EMAIL}">${EMAIL}</a>.`,
      content_bank_account: `Chcete-li změnit číslo účtu, kontaktujte naši zákaznickou linku na čísle <a href="tel:${PHONE_LINK}">${PHONE}</a> nebo e-mailem na adrese <a href="mailto:${EMAIL}">${EMAIL}</a>.`,
      content_address: `Chcete-li změnit adresu, kontaktujte naši zákaznickou linku na čísle <a href="tel:${PHONE_LINK}">${PHONE}</a> nebo e-mailem na adrese <a href="mailto:${EMAIL}">${EMAIL}</a>.`,
      content_email: 'Váš aktuální e-mail je:',
      content_email_done: 'Váš e-mail byl úspěšně změněn.',
      content_phone: `Chcete-li změnit telefonní číslo, kontaktujte naši zákaznickou linku na čísle <a href="tel:${PHONE_LINK}">${PHONE}</a> nebo e-mailem na adrese <a href="mailto:${EMAIL}">${EMAIL}</a>.`,
      placeholder_email: 'Nová e-mailová adresa',
      old_password_placeholder: 'Původní heslo',
      new_password_placeholder: 'Nové heslo',
      confirm_new_password_placeholder: 'Potvrzení nového hesla',
      content_confirm_password: 'Prosím zadejte své heslo ještě jednou',
      content_password:
        'Heslo musí mít délku nejméně 7 znaků a musí obsahovat minimálně 1 číslici. Pozor, heslo rozlišuje velká a malá písmena. Nepoužívejte v hesle znaky s diakritikou.',
      content_password_done: 'Heslo bylo úspěšně změněno',
      change_email_verify: {
        header: 'Potvrzovací kód zaslán na',
        pin_header: 'Potvrzovací kód',
        get_new_code: 'Znovu zaslat kód',
      },
      confirm_btn: 'Mám to',
      change_btn: 'POTVRDIT',
    },
  },

  login: {
    html_title: 'Přihlášení do zákaznického účtu - kimbi.cz',
    title: 'Přihlášení do zákaznického účtu',
    email: 'Email',
    password: 'Heslo',
    submit: 'Přihlásit se',
    forgot_password: 'Nepamatujete si heslo?',
    have_questions: 'Nějaké otázky?',
    back_url: 'Zpět na předchozí stránku',
    contact_details_holiday: `Kontaktujte naši zákaznickou linku na <a href="tel:${PHONE_LINK}">${PHONE}</a> nebo emailem <a href="mailto:${EMAIL}">${EMAIL}</a>.`,
    contact_details: `Kontaktujte naši zákaznickou linku na <a href="tel:${PHONE_LINK}">${PHONE}</a> nebo emailem <a href="mailto:${EMAIL}">${EMAIL}</a>.`,
  },

  twoFa: {
    html_title: 'Ověření telefonního čísla - kimbi.cz',
    title: 'Ověření telefonního čísla',
    subtitle:
      'Zadejte kód, který jsme vám zaslali prostřednictvím SMS na mobilní číslo, které jste si zaregistrovali u společnosti Zaplo.',
    email: 'Email',
    password: 'Heslo',
    submit: 'Přihlásit se',
    resend: 'Znovu odeslat kód',
    have_questions: 'Nějaké otázky?',
    info: 'Tyto další kroky zajišťují bezpečnost a soukromí vašeho účtu. Tímto způsobem potvrzujeme vaši totožnost a chráníme přístup k vašemu profilu.',
    contact_details: `Může chvíli trvat, než Vám SMS dorazí. Pokud jste SMS neobdrželi, tak pro dokončení žádosti kontaktujte naši zákaznickou linku na <a href="tel:${PHONE_LINK}">${PHONE}</a> nebo emailem <a href="mailto:${EMAIL}">${EMAIL}</a>.`,
  },

  password_recovery: {
    html_title: 'Zapomenuté heslo - kimbi.cz',
    heading: 'Zapomenuté heslo',
    email: 'Email',
    continue: 'POKRAČOVAT',
    description: 'Zadejte Vaši emailovou adresu',
    help_heading: 'Nějaké otázky?',
    help_info: `Kontaktujte naši zákaznickou linku na <a href="tel:${PHONE_LINK}">${PHONE}</a> nebo emailem <a href="mailto:${EMAIL}">${EMAIL}</a>`,
    help_info_holidays: `Kontaktujte naši zákaznickou linku na <a href="tel:${PHONE_LINK}">${PHONE}</a> nebo emailem <a href="mailto:${EMAIL}">${EMAIL}</a>`,
  },

  password_recovery_sent: {
    html_title: 'Dočasné heslo odesláno na email - kimbi.cz',
    heading: 'Dočasné heslo odesláno na email',
    description:
      'Na Váš email jsme odeslali dočasné heslo, kterým se nyní můžete přihlásit.',
    continue: 'Přihlásit se',
  },

  password_recovery_new_password: {
    html_title: 'Vytvořit nové heslo - kimbi.cz',
    heading: 'Vytvořit nové heslo',
    new_password: 'Nové heslo',
    confirm_new_password: 'Potvrzení nového hesla',
    submit: 'ULOŽIT',
  },

  password_recovery_new_password_set: {
    html_title: 'Heslo bylo úspěšně změněno - kimbi.cz',
    heading: 'Heslo bylo úspěšně změněno',
    continue: 'POKRAČOVAT',
  },

  payments: {
    html_title: 'Potřebujete více času? - kimbi.cz',
    heading: 'Potřebujete více času?',
    repayment: 'Splacení půjčky',
    extension: 'Prodloužení splatnosti půjčky',
    contract_number: 'Smlouva č.: {{loanNumber}}',
    step_1: 'Výběr možnosti platby',
    step_2: 'Proveďte platbu',
    step_3: 'Hotovo',
    extension_label_30: 'Prodloužit splatnost Vaší půjčky o 30 dní za:',
    extension_label_14: 'Prodloužit splatnost Vaší půjčky o 14 dní za:',
    extension_label_7: 'Prodloužit splatnost Vaší půjčky o 7 dní za:',
    repayment_label: 'Splatit celou půjčku (splatnost {{paymentDate}})',
    bank_info_0: 'Zkopírujte si platební údaje nebo použijte QR kód.',
    bank_info_1: 'Otevřete svou online banku.',
    bank_info_2: 'Proveďte splátku pomocí následujících platebních údajů.',
    bank_info_3: 'Částku k úhradě si zvolte podle Vaší potřeby',
    bank_placeholder: 'Vyberte banku',
    bank_separator: 'NEBO',
    account_number: 'Číslo účtu',
    receiver: 'Příjemce',
    variable_symbol: 'Variabilní symbol',
    transfer_amount: 'Částka k úhradě',
    copy: 'KOPÍROVAT',
    copied: 'Zkopírováno',
    bank_info_subtitle:
      'Pro provedení platby použijte uvedené platební informace. Písemné potvrzení o přijetí Vaší platby Vám zašleme formou SMS a e-mailem v okamžiku, kdy platba dorazí na náš účet.',
    bank_info_subtitle_ext:
      'Pro prodloužení splatnosti Vaší půjčky použijte uvedené platební údaje. Písemné potvrzení o prodloužení splatnosti Vám zašleme formou sms a e-mailem v okamžiku přijetí Vaší platby.',
    agreement: 'Smlouva o úvěru',
    qrcode_notice:
      'Naskenujte QR kód pomocí mobilního telefonu a proveďte bankovní převod',
    qrcode_tooltip:
      'Naskenováním QR kódu nemusíte ručně kopírovat všechny údaje.',
    discount_banner: 'Máme pro vás {{discountPercent}}% slevu',
    discount_till: 'do {{endDate}}',
    download: 'stáhnout',
    due_date: 'Datum splatnosti: {{dueDate}}',
    custom_payment_title: 'Mimořádná splátka',
    repayment_subtitle: {
      full: 'Splatit půjčku',
      minimum: 'První minimální měsíční splátka',
      custom: 'Mimořádná splátka',
    },
  },

  not_found: {
    html_title: 'Stránka nenalezena - kimbi.cz',
    title: 'Stránka nenalezena',
    description:
      'Něco se vymňouklo. Stránka, na kterou se chcete dostat, bohužel neexistuje.',
    continue_btn: 'vrátit se domů',
  },

  income_proof_notification: {
    heading: 'Kopie potvrzení o příjmu',
    p_1: 'Zašlete nám prosím kopii některého z následujících dokumentů\n(ne starší 3 měsíců a to ve formátu: jpg, png nebo pdf):',
    item_1: 'Bankovní výpis',
    item_2: 'Potvrzení o příjmu od Vašeho zaměstnavatele',
    item_3: 'Výplatní pásku',
    item_4: 'Potvrzení o dávkách od státní správy sociálního zabezpečení',
    item_5: 'Potvrzení o výši důchodu',
    item_6: 'Potvrzení o výši dávek v nezaměstnanosti',
    item_7: 'Potvrzení příjmu na mateřské dovolené',
    p_2: `V případě, že jste dosud nezaslali požadované dokumenty,\nzašlete je co nejdříve na následující e-mailovou adresu ${EMAIL}`,
  },

  id_proof_notification: {
    heading: 'Ověření totožnosti',
    p_1: 'Platnost Vašeho Občanského průkazu vypršela.',
    p_2: 'Prosíme, nahrajte nám Váš nový Občanský průkaz stisknutím tlačítka “Nahrát nyní”',
    btnText: 'Nahrát nyní',
  },

  discount: {
    additional_amount: 'Navýšit o',
    interest_before_discount: 'Úroková sazba před slevou',
    discount_applied: 'Sleva',
    discount_percent: 'Máme pro vás {{percent}}% slevu',
    discount_percent_short: '{{percent}}% slevu',
    discount_valid_to: 'do {{date}}',
  },

  psd2_account_confirm: {
    html_title: 'Potvrďte číslo účtu - kimbi.cz',
    heading_mobile: 'Potvrďte číslo účtu',
    card_title: 'Bankovní údaje ',
    card_subtitle:
      'Na tento účet Vám odešleme peníze. Zkontrolujte si, že je účet správný.',
    confirm_button: 'ANO, účet je správně​',
    change_account_button: 'Ne, účet potřebuji změnit',
  },
  psd2_account_instructions: {
    html_title: 'Změna bankovního účtu - kimbi.cz',
    heading_mobile: 'Změna bankovního účtu',
    title: 'Změna bankovního účtu',
    card_title: 'Účet pro zaslání platby:',
    subtitle:
      'Pro změnu bankovního účtu je nutné provést za účelem identifikace ověřovací platbu ve výši 0,01 Kč (tj. jeden haléř). Platbu proveďte pod variabilním symbolem na níže uvedený účet.',
    confirm_button: 'Rozumím​',
    bank_info: {
      amount_to_be_paid: 'Částka k úhradě',
      variable_symbol: 'Variabilní symbol',
      recipient: 'Příjemce',
      account_number: 'Číslo účtu',
    },
  },
  psd2_manual: {
    html_title: 'Ověření bankovního účtu - kimbi.cz',
    heading_mobile: 'Nová nabídka',
    title: 'Ověření bankovního účtu',
    card_title: 'Účet pro zaslání platby:',
    subtitle:
      'Za účelem identifikace ověřovací platbu ve výši 0,01 Kč (tj. jeden haléř). Platbu proveďte pod variabilním symbolem na níže uvedený účet.',
    confirm_button: 'Rozumím​',
    bank_info: {
      amount_to_be_paid: 'Částka k úhradě',
      variable_symbol: 'Variabilní symbol',
      recipient: 'Příjemce',
      account_number: 'Číslo účtu',
    },
  },
  psd2_banks: {
    html_title: 'Nová nabídka - kimbi.cz',
    heading_mobile: 'Nová nabídka',
    title: 'Ověření bankovního účtu',
    subtitle: 'Vybraný účet bude použit k ověření příjmu.',
    search: 'Zadejte jméno banky',
    card_title: 'Vybraný účet bude použit k ověření příjmu.',
    card_title_bank:
      'Vyberte si svou banku, u které máte vedený bankovní účet na Vaše jméno.',
    card_subtitle:
      'Budete přesměrování na přihlašovací stránku vaší banky, kde se přihlásíte stejným způsobem jako do Vašeho internetového bankovnictví.',
    manual:
      'Pokud není Vaše banka na seznamu, můžete nám nahrát potvrzení o příjmu na následující stránce.',
    continue: 'Pokračovat',
    skip: 'Přeskočit',
    card_btn: 'Moje banka není na seznamu',
  },

  psd2_guide: {
    html_title: 'Ověření bankovního účtu – kimbi.cz',
    title: 'Návod pro přihlášení do internetového bankovnictví',
    continue: 'Pokračovat',
    back: 'Zpět na výběr banky',
    default: {
      step_1: 'Přihlaste se do zvolené banky.',
      step_2: 'Po přihlášení připravíme stažení výpisů a ověřovací platbu.',
      step_3: 'Údaje jen potvrdíte a z účtu vás následně bezpečně odhlásíme.',
    },
  },

  psd2_consents: {
    heading_mobile: 'Souhlas',
    skip: 'Přeskočit',
    page_title: 'Udělení souhlasu',
    html_title: 'Udělení souhlasu – kimbi.cz',
    description:
      'V následujícím kroku budete přesměrováni na přihlašovací stránku do internetového bankovnictví banky',
  },

  psd2_bank_account_select: {
    heading_mobile: 'Souhlas',
    html_title: 'Ověření bankovního účtu - kimbi.cz',
    page_title: 'Ověření bankovního účtu',
    description:
      'Ve Vašem bankovnictví jsme našli více účtů. Zvolte jeden účet, který chcete použít pro odeslání ověřovací platby ve výši 0,01 Kč.',
    account_label: 'Osobní účet CZK',
  },

  psd2_receiving: {
    heading_mobile: 'Souhlas',
    html_title: 'Ověření bankovního účtu - kimbi.cz',
    page_title: 'Ověření bankovního účtu',
    description:
      'Probíhá zpracování Vaší transakční historie. Prosíme o strpení, může to trvat několik minut ',
  },

  expired_income: {
    html_title: 'Nemáme platné potvrzení o příjmu  - kimbi.cz',
    heading: 'V tuto chvíli od Vás nemáme platné potvrzení o příjmu. ',
    desc: 'Stisknutím tlačítka "POKRAČOVAT" se dostanete na stránku s výběrem bank. Zvolte svou banku ve které máte vedený účet na Vaše jméno a digitálně ověřte svůj příjem nebo zvolte možnost nahrání příloh dokládající Váš příjem.',
    btn: 'Pokračovat',
  },

  psd2_receiving_done: {
    html_title: 'Ověření bankovního účtuproběhlo v pořádku - kimbi.cz',
    page_title: 'Ověření bankovního účtu',
    item_1: 'Zpracování transakční historie proběhlo v pořádku.',
    item_2: 'Z účtu jsme Vás bezpečně odhlásili.',
    continue: 'Pokračovat',
    page_title_pdf_parser:
      'Děkujeme,\n Vámi poskytnuté údaje budou nyní zpracovány a vyhodnoceny.',
  },

  psd2_verified: {
    html_title: 'Ověření bankovního účtu proběhlo v pořádku - kimbi.cz',
    page_title: 'Ověření bankovního účtu proběhlo v pořádku.',
    heading_mobile: 'Nová nabídka',
    complete: 'Dokončit žádost',
  },

  psd2_approved: {
    html_title: 'Nová nabídka - kimbi.cz',
    page_title: 'Vaše žádost o půjčku byla schválena',
    heading_mobile: 'Nová nabídka',
    description:
      'Peníze odesíláme ihned nebo vždy nejbližší pracovní den. Smlouvu naleznete v sekci informace o půjčce',
    complete: 'Zákaznický účet',
  },

  adjust_income: {
    income_discrepancy_title: 'Rozdíl v uvedeném příjmu',
    declared_income: 'Vámi uvedený příjem',
    verified_bank_income: 'Ověřený příjem z účtu',
    please_select_how_to_proceed:
      'Prosím, vyberte, jak chcete dále pokračovat:',
    continue_with_verified_income: 'Pokračovat s ověřeným příjmem',
    continue: 'Pokračovat',
    submit_other_proof_of_income: 'Předložit jiný doklad o příjmu',
    upload_attachments: 'Nahrát přílohy',
    income_verification_message:
      'Vážený kliente,\n na základě ověření příchozích plateb na Vašem bankovním účtu jsme zjistili nižší příjem, než uvádíte.',
  },

  psd2_error: {
    html_title: 'Omlouváme se, něco se pokazilo - kimbi.cz',
    page_title: 'Omlouváme se, něco se pokazilo.',
    continue_button: 'Pokračovat',
    title: 'Chyba při zpracování příjmu',
    description:
      'Vážený kliente, při zpracování Vašeho příjmu došlo k neočekávané chybě.',
    description_old_statement:
      'Nahraný bankovní výpis není za požadované období posledních 3. měsíců. Pro ověření příjmů akceptujeme výpis z bankovního účtu za poslední 3 měsíce, výplatní pásky za poslední 3 měsíce nebo potvrzení o příjmu od zaměstnavatele.',
    description_password_protected:
      'Nahrané přilohy se nepodařilo otevřít, je možné, že jsou zaheslovány. Přílohy můžete zkusit zaslat znovu nezaheslované nebo využít jinou z níže uvedených možností.',
    description_processing_error:
      'Vážený kliente, při zpracování Vašeho příjmu došlo k neočekávané chybě.',
    description_unsupported_format:
      'Vámi poskytné dokumenty jsme nedokázali zpracovat.<br>V případě, že jste nahrali výplatní pásky, vyčkejte až Vás budeme kontaktovat nebo zvolte jiný způsob ověření příjmu.',
    description_name_mismatch:
      'Vámi dodané výpisy z účtu nejsou vedeny na Vaše jméno.',
    description_no_income:
      'Na Vámi dodaných výpisech z účtu jsme nenašli žádný příjem.',
    description_invalid_account_type: 'Vámi zvolený typ účtu není podporován.',
    description_account_name_mismatch:
      'Vámi zvolený bankovní účet není vedený na Vaše jméno.',
    description_account_no_income:
      'Na Vámi zvoleném bankovním účtu jsme nenašli žádný příjem.',
    select_option:
      'Prosím, vyberte jednu z následujících možností, jak chcete dále pokračovat:',
    select_option_description: `Pokud nevyberete žádnou z možností, nevadí. Budeme Vás sami kontaktovat v pracovní dny mezi 8:00 a ${TIME_WORKING_END_HOURS} hodinou.`,
    verify_online: 'Ověřit příjem online',
    verify_online_button: 'Ověřit online',
    verify_upload: 'Ověřit příjem nahráním příloh',
    verify_upload_button: 'Nahrát přílohy',
    send_email: 'Zaslat emailem',
    send_email_button: 'Zaslat email',
  },

  waiting_page: {
    html_title: 'Analýza Vašich osobních údajů - kimbi.cz',
    title: 'Zpracováváme Vaší žádost',
    info: 'Buďte prosím trpěliví a nezavírejte tuto stránku, může to trvat až 1 minutu.',
  },

  loading_screen: {
    title: 'Zpracováváme Vaší žádost',
    subtitle:
      'Buďte prosím trpěliví a nezavírejte tuto stránku, může to trvat až 1 minutu.',
  },

  promo: {
    html_title: 'Akce pro zákazníky - kimbi.cz',
    heading_mobile: 'Akce pro zákazníky',
    title: 'Akce pro zákazníky',
    text: 'Objevte všechny nabídky, které jsme pro vás připravili ve spolupráci s našimi partnery.',
  },

  faq: {
    html_title: 'Často kladené dotazy - kimbi.cz',
    heading_mobile: 'Často kladené dotazy',
    title: 'Často kladené dotazy',
    banner_title: 'Máte otázky týkající se vaší půjčky nebo možností platby?',
    banner_desc:
      'Sestavili jsme seznam nejčastějších dotazů, které vám pomohou pochopit vše od výše jistiny až po termíny splátek.',
    question_1: 'Co je jistina?',
    answer_1:
      'Jistina půjčky je částka, kterou si dlužník půjčí od věřitele, tedy původní hodnota půjčky bez úroků a dalších poplatků. Je to základní suma, na kterou se následně vypočítávají úroky.',
    question_2: 'Co je Minimální měsíční splátka?',
    answer_2:
      'Minimální měsíční splátka je nejmenší možná částka, kterou je potřeba každý měsíc uhradit. Minimální měsíční splátka obsahuje:<ul><li>5% z aktuální jistiny</li><li>Úroky k danému datu splátky</li></ul>Minimální měsíční splátku je třeba uhradit v dané (popř. vyšší) částce. V případě zaslání nižší částky než je Minimální měsíční splátka, je platba zaúčtována jako klasická (mimořádná) splátka a Minimální měsíční splátka bude v daný okamžik přepočítána dle aktuální jistiny.',
    question_3: 'Co je celková splatná částka půjčky k dnešnímu dni?',
    answer_3:
      'Je to celková částka, kterou klient dluží k danému dni. Částka obsahuje aktuální jistinu + úroky k danému dni. Jelikož je Kimbi půjčka úročena denním úročením, je vždy připočítán úrok POUZE za každý další den.',
    question_4: 'Co znamená, že je půjčka úročena na denní bázi?',
    answer_4:
      'Denní úročení půjčky znamená, že úrok se počítá každý jednotlivý den z částky zbývající jistiny půjčky. Každý den se tedy úrok vypočítá z aktuální výše dluhu. Díky dennímu úročení je možné kdykoliv celou půjčku splatit a klient nezaplatí žádné úroky navíc.',
    question_5: 'Jaký je rozdíl mezi Dočerpáním půjčky a Navýšením půjčky',
    answer_5:
      '<p>Dočerpání znamená, že po zaplacení jakékoliv částky (převyšující 500 Kč) máte možnost okamžitě dočerpat finanční prostředky až do výše vaší čerpané půjčky poskytnuté na základě sjednané smlouvy o úvěru. Tzn. např. pokud máte půjčku 10 000 Kč, po 10 dnech splatíte 3 000 Kč, tak si můžete jednoduše ihned dočerpat částku 2 452 Kč (částka 3 000 Kč je ponížena o úroky za 10 dní, tzn. aktuální výše půjčky je 7 548 Kč).</p><p>Navýšení půjčky znamená, že zažádáte o navýšení částky převyšující částku čerpané půjčky. V takovém případě je žádost potřeba vyhodnotit a je vystaven dodatek ke stávající smlouvě.</p><p>Tzn. pokud máte např. půjčku 10 000 Kč, po 10 dnech jste splatili 3 000 Kč a nyní žádáte o 5 000 Kč, jedná se o navýšení půjčky (požadovaná částka převyšuje původní částku půjčky). Pokud bude žádost v pořádku vyhodnocena a bude schválena, celková výše půjčky bude 12 548 Kč (aktuální výše půjčky 7 548 Kč + 5 000 Kč).</p>',
    footer_title: 'Potřebujete další pomoc?',
    footer_desc:
      'Pro podrobnější scénáře a příklady toho, jak fungují platby a úroky, navštivte naši stránku s ',
    footer_desc_link: 'příklady půjček',
  },

  loan_examples: {
    html_title: 'Příklady půjček - kimbi.cz',
    heading_mobile: 'Příklady půjček',
    section_1: {
      title: 'Vzorové příklady',
      badge_1: 'Příklad 1',
      title_1: 'Zaplacení Minimální měsíční splátky před datem splatnosti',
      desc_1:
        '<p>Pan Novák si 10. 5. 2024 vzal půjčku ve výši 10 000 Kč. Minimální měsíční splátka je tedy splatná k 9. 6. 2024 (30 dní) ve výši 2 144 Kč. Pan Novák se ale rozhodne zaslat částku 2 144 Kč již 10. den, tzn. 20. 5. 2024.</p><p>Touto platbou je uhrazena Minimální měsíční splátka a zaúčtována je následovně:</p><ul><li>500 Kč na snížení jistiny (5% z Minimální měsíční splátky je účtováno na umořování / snižování jistiny)</li><li>548 Kč úroky (úroky pouze za aktuálních 10 dní, ÚROKY NIKDY neúčtujeme dopředu)</li><li>Zbývajících 1 096 Kč (tj. 2 144 – 500 – 548) na snížení jistiny</li></ul><p>Jelikož je již za daný měsíc Minimální měsíční splátka uhrazena, uvidí pan Novák na svém Zákaznickém účtu, že Minimální měsíční splátka byla již uhrazena a další bude k dispozici za 20 dní.</p><p>Za 20 dní (tzn. 9. 6. 2024) uvidí pan Novák ve svém Zákaznickém účtu:</p><ul><li>Celková splatná částka půjčky k dnešnímu dni 9 325 Kč (tj. jistina + úroky od poslední uhrazené Minimální měsíční splátky)</li><li>Minimální měsíční splátka k 9. 7. 2024 ve výši 2 723 Kč</li></ul><p>(předešlá Minimální měsíční splátka 2 144 Kč byla uhrazena již po 10 dnech, tzn. byly v ní naúčtovány úroky pouze za daných 10 dní. Úroky za zbývajících 20 dní v rámci měsíce jsou proto zahrnuty do následující Minimální měsíční splátky).</p>',
      badge_2: 'Příklad 2',
      title_2: 'Uhrazení nižší částky než je Minimální měsíční splátka',
      desc_2:
        '<p>Pan Novák si 10. 5. 2024 vzal půjčku ve výši 10 000 Kč. Minimální měsíční splátka je tedy splatná k 9. 6. 2024 (30 dní) ve výši 2 144 Kč. Pan Novák po 10 dnech uhradil částku 2 000 Kč.</p><p>Jelikož je uhrazená částka nižší než stanovená Minimální měsíční splátka, je částka zaúčtována jako klasická mimořádná splátka, kdy jde část na uhrazení úroků za 10 dní a zbývající částka na umoření (snížení) jistiny.</p><p>Nyní je tedy Celková splatná částka půjčky k dnešnímu dni 8 548 Kč (548 Kč bylo zaúčtováno na úrok za 10 dní, zbylá částka 1 452 Kč byla zaúčtována na snížení jistiny).</p><p>Zároveň se v daný okamžik na základě aktuální celkové splatné částky přepočítá i Minimální měsíční splátka, kterou je stále třeba uhradit, a to následovně:</p><ul><li>5% z aktuální jistiny (z 8 548 Kč)</li><li>Úroky za zbývajících 20 dní</li></ul><p>Minimální měsíční splátka, kterou je třeba uhradit k 9. 6. 2024 bude tedy 1 364 Kč.</p>',
    },
    note: 'Upozornění: uvedené příklady jsou ilustrativní při maximální úrokové sazbě.',
  },

  new_offer_details: {
    loan: 'Výše půjčky',
    title_1: 'Při splacení do 30 dnů',
    totalRepayableAmount: 'Celková splatná částka:',
    interestRate: 'Výše úrokové sazby:',
    firstPaymentDate: 'Datum splatnosti:',
    title_2: 'Při splacení v podobě minimální měsíční splátky',
    extensionFees: 'První minimální mesíční splátka:',
    futureExtensionFees: 'Následující minimální měsíční splátka:',
    assignedInterest: 'Výše úrokové sazby po uplynutí prvních 30 dnů:',
    paymentDate: 'Datum splatnosti první minimální měsíční splátky:',
    interest: 'Výše úrokové sazby ',
    first_30_days: ' prvních 30 dnů',
    after_first_30_days: ' po uplynutí prvních 30 dnů',
  },

  phoneCode: {
    title: 'Podepsání smlouvy',
    mobile_heading: 'Podpis',
    desc: 'Pro podepsání této smlouvy o úvěru zadejte kód, který Vám byl zaslán na Vaši emailovou adresu <strong>{{email}}</strong> a telefonní číslo <strong>{{phone}}</strong>',
    otpLabel: 'Potvrzovací kód',
    resendText: 'Kód nedorazil?',
    resendBtn: 'Znovu zaslat kód',
    submitBtn: 'Podepsat a potvrdit',
    footerText: `Může chvíli trvat, než Vám Email spolu s SMS dorazí. Pokud jste neobdrželi email, zkontrolujte si složku nevyžádané pošty/spam, nebo si nechte kód zaslat znovu.
                 V případě opakovaného problému kontaktujte naši zákaznickou linku na <a href="tel:${PHONE_LINK}">${PHONE}</a> nebo emailem <a href="mailto:${EMAIL}">${EMAIL}</a>`,
    cancelText: 'Rozmysleli jste si to nebo narazili na technický problém?',
    cancelBtn: 'Zrušit žádost',
  },
  withdraw_contract_flow: {
    introConfirm: {
      title: 'Odstoupení od smlouvy',
      desc: 'Odstoupením se smlouva ruší, budete povinen/povinna vrátit čerpanou částku úvěru a <b>zaplatíte úrok za dobu</b>, kdy jste měl/a peníze k dispozici, tedy <b>od čerpání do vrácení.</b>',
      // table
      yourContract: 'Vaše smlouva',
      contactNumber: 'Číslo smlouvy',
      interest: 'Výše nesplacených úroků<br/>k dnešnímu dni',
      principalAmount: 'Výše nesplacené jistiny',
      // red card
      amountPaid: 'Aktuální částka ke splacení',
      todayTitle: 'Tato částka je platná pouze dnes',
      todayDesc:
        'Částka platí pro odeslání platby dnes. S každým dalším dnem se zvyšuje o denní úrok.',
      // buttons
      back: 'Zpět',
      submit: 'Pokračovat k odstoupení',
      // questions/footer
    },
    warning: {
      title: 'Než budete pokračovat',
      desc: 'Odstoupení je vážný krok. Přečtěte si prosím, co přesně se stane — chceme, abyste rozhodovali s plným přehledem.',
      cards: {
        first: {
          title: 'Smlouva zanikne',
          desc: 'K dnešnímu dni vám zaniknou veškeré závazky vyplývající ze smlouvy, kromě povinnosti vrátit jistinu a úrok. I po odstoupení od smlouvy se úrok dále počítá, dokud nebude půjčená částka skutečně vrácena. Výše úroku proto závisí na dni, kdy úvěr splatíte.',
        },
        second: {
          title: 'Celkem k vrácení dnes {{amount}}',
          desc: 'Částka platí pro odeslání platby dnes.  S každým dalším dnem se zvyšuje o denní úrok.',
        },
        third: {
          title: 'Akce nejde vrátit zpět',
          desc: 'Po odeslání podepsaného formuláře nelze odstoupení zrušit. O nový úvěr můžete požádat kdykoli později.',
        },
      },
      greenCard: {
        title: 'Nemusíte odstoupit hned',
        desc: `Pokud jen potřebujete odložit splátku, kontaktujte nás na <a href="tel:${PHONE_LINK}">${PHONE}</a>.  Najdeme řešení.`,
      },
      // buttons
      backBtn: 'Zrušit a vrátit se',
      submitBtn: 'Rozumím, pokračovat',
    },
    consents: {
      title: 'Poslední krok',
      desc: 'Pro odeslání žádosti potvrďte následující prohlášení.',
      // table
      table: {
        title: 'Vaše smlouva',
        contractNumber: 'Číslo smlouvy',
        clientName: 'Jméno a příjmení',
        refundable: 'K vrácení',
        validToday:
          'Částka platí pro odeslání platby dnes. S každým dalším dnem se zvyšuje o denní úrok.',
      },
      // consents
      consent1:
        'Souhlasím s výše uvedeným a rozumím, že odstoupením od smlouvy zaniknou všechny mé závazky kromě povinnosti vrátit <b>{{amount}} (Tato částka je platná pouze dnes)</b>',
      consent2:
        'Rozumím, že tento krok je <b>nevratný</b> a po odeslání ho nelze zrušit.',
      consent3:
        'Souhlasím, že potvrzení o odstoupení od smlouvy obdržím na Váš kontaktní e-mail <b>{{email}}</b>',
      // buttons
      back: 'Zpět',
      submit: 'Potvrzuji odstoupení od smlouvy',
    },
    dashboardWithdraw: {
      notification: {
        green: {
          title: 'Odstoupení od smlouvy v procesu',
          desc: 'Čekáme na vrácení částky.',
        },
        orange: {
          title: 'Poslední den lhůty',
          desc: 'Zaplaťte dnes a vyhněte se pokutě a úroku z prodlení',
        },
      },
      title: 'Vrátit půjčku',
      timerCard: {
        whiteSection: {
          title: 'K vrácení celkem DNES',
          desc: 'Částka platí pro odeslání platby dnes. S každým dalším dnem se zvyšuje o denní úrok.',
        },
        greenSection: {
          title: 'Lhůta na vrácení peněz',
          desc: 'Splatnost <b>{{today}}</b> · DNES',
        },
        orangeCard: {
          title: 'Zbývá do konce lhůty',
          desc: 'Splatnost dnes do 23:59 · rozhoduje datum připsání na účet',
        },
      },
    },
    dashboardBrokenWithdraw: {
      title: 'Váš úvěr číslo: {{loanNumber}},<br>byl zesplatněn',
      amountLabel: 'K vrácení celkem DNES',
      instructionAccount: 'Platbu poukažte IHNED na bankovní účet',
      instructionSymbol: 'Do pole variabilní symbol uveďte číslo úvěru',
      warning:
        'V případě, že nemáte na zaplacení celé částky, kontaktujte naše oddělení pohledávek na tel. <b>800 999 955</b>, kde s vámi probereme možnosti splácení.',
    },
    qrCard: {
      title: 'Zaplaťte prosím nyní',
      desc: 'Otevřete bankovní aplikaci a zaplaťte pomocí QR kódu nebo bankovních údajů níže.',
      footer:
        'Naskenujte nebo si stáhněte QR kód pomocí mobilního telefonu a proveďte bankovní převod',
      // table
      table: {
        accountNumber: 'Číslo účtu',
        beneficiary: 'Příjemce',
        symbol: 'Variabilní symbol',
        todayPaid: 'Částka k úhradě dnes',
      },
    },
  },
};

export default cz;
